import styled from 'styled-components';

export const HomeWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
`;

HomeWrapper.displayName = 'HomeWrapper';